import { useAccount } from 'wagmi'
import { useUser } from '@/hooks/use-user'
import { useLinkedWallets } from '@/hooks/use-linked-wallets'

export type ActiveWalletKind = 'custodial' | 'external' | 'none'

interface ActiveWalletInfo {
	walletAddress?: `0x${string}`
	kind: ActiveWalletKind
	connectorName?: string
	custodialAddress?: `0x${string}`
	isExternal: boolean
	isCustodial: boolean
	isLinked: boolean
	canSend: boolean
}

const eqAddress = (a?: string | null, b?: string | null) =>
	!!a && !!b && a.toLowerCase() === b.toLowerCase()

export function useActiveWallet(): ActiveWalletInfo {
	const user = useUser()
	const custodialAddress = user?.walletAddress as `0x${string}` | undefined
	const { address: externalAddress, connector, isConnected } = useAccount()
	const { isAddressLinked } = useLinkedWallets()

	const connectorName = connector?.name

	if (isConnected && externalAddress && !eqAddress(externalAddress, custodialAddress)) {
		const isLinked = isAddressLinked(externalAddress)
		return {
			walletAddress: externalAddress as `0x${string}`,
			kind: 'external',
			connectorName,
			custodialAddress,
			isExternal: true,
			isCustodial: false,
			isLinked,
			canSend: isLinked
		}
	}

	if (custodialAddress) {
		return {
			walletAddress: custodialAddress,
			kind: 'custodial',
			connectorName,
			custodialAddress,
			isExternal: false,
			isCustodial: true,
			isLinked: true,
			canSend: true
		}
	}

	return {
		walletAddress: undefined,
		kind: 'none',
		connectorName,
		custodialAddress,
		isExternal: false,
		isCustodial: false,
		isLinked: false,
		canSend: false
	}
}
